import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@core/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrderHistoryComponent } from './orderhistory/orderhistory.component';
import { OrderManagementService } from './service/ordermanagement.service';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        NgbModule,
        FormsModule,
        NgbAccordionModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [OrderManagementService],
    declarations: [
        OrderHistoryComponent
    ]
})
export class OrderManagementModule { }